import {merge, Observable} from "rxjs";
import {DeepLinkService} from "@app/core/shared/infrastructure/interfaces/deep-link.service";
import {DeepLink} from "@app/core/shared/domain/entities/deep-link";
import {PushNotificationsService} from "@app/core/notifications/infrastructure/interfaces/push-notifications.service";
import {UrlDeepLinkService} from "@app/core/shared/infrastructure/url-deep-link.service";
import {Injectable} from "@angular/core";

/**
 * DeepLinkService implementation for handling native deep links within the application.
 * This implementation listens for deep links from two sources: URL deep links and push notifications.
 */
@Injectable()
export class NativeDeepLinkService implements DeepLinkService {

    constructor(
        private urlDeepLinkService: UrlDeepLinkService,
        private pushNotificationsService: PushNotificationsService,
    ) {
    }

    /**
     * Emits a DeepLink when the app receives a deep link.
     */
    public getDeepLink(): Observable<DeepLink> {
        return merge(
            this.urlDeepLinkService.getDeepLink(),
            this.pushNotificationsService.getDeepLink(),
        )
    }
}

